import { useState, useCallback } from 'react';
import { ApiError, isRateLimitError, getRetryAfterSeconds } from '@/services/errorHandler';

export const useRateLimit = () => {
  const [rateLimitError, setRateLimitError] = useState<ApiError | null>(null);

  const handleError = useCallback((error: any): boolean => {
    if (isRateLimitError(error)) {
      const retryAfter = getRetryAfterSeconds(error);
      setRateLimitError({
        message: `You've made too many requests. Please wait ${retryAfter} seconds before trying again.`,
        status: 429,
        isRateLimit: true,
        retryAfter
      });
      return true; // Error was handled
    }
    return false; // Error was not a rate limit error
  }, []);

  const clearRateLimitError = useCallback(() => {
    setRateLimitError(null);
  }, []);

  const retryAction = useCallback((action: () => void) => {
    clearRateLimitError();
    action();
  }, [clearRateLimitError]);

  return {
    rateLimitError,
    handleError,
    clearRateLimitError,
    retryAction
  };
}; 